export const getNumberOfColumnsInTable = (selector) => {
    const table = document.querySelector(selector);
    if (table) {
        const firstRow = table.rows[0];
        if (firstRow) {
          let visibleColumnCount = 0;
          for (let i = 0; i < firstRow.cells.length; i++) {
            const cell = firstRow.cells[i];
            if (getComputedStyle(cell).display !== 'none') {
              visibleColumnCount++;
            }
          }
          return visibleColumnCount;
        }
      }
    return 0
}
  